import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['header', 'body', 'footer']

  header (content) {
    const closeIcon = `
      <div><i class="modal-close far fa-times-circle" data-action="click->modal#hide"></i></div>
    `

    this.headerTarget.innerHTML = (content || '') + closeIcon
  }

  body (content) {
    if (!content) return
    this.bodyTarget.innerHTML = content
  }

  footer (content) {
    if (!content) return
    this.footerTarget.innerHTML = content
  }

  show ({ detail }) {
    this.header(detail.header)
    this.body(detail.body)
    this.footer(detail.footer)
    this.element.setAttribute('style', 'display: block;')
  }

  hide () {
    this.element.removeAttribute('style')
  }

  outsideModal (event) {
    if (event.target === this.element) {
      this.hide()
    }
  }
}
